import { log } from './debug';

export const triggerPathAndQuery = (triggerPath) => {
  try {
    const triggerPathSplit = triggerPath.indexOf('?!') > -1 ? [triggerPath] : triggerPath.split('?');
    let triggers = new RegExp(triggerPathSplit[0]).test(location.pathname);

    if (triggers && triggerPathSplit.length > 1) {
      if (typeof URLSearchParams !== 'undefined' && location.search && location.search.length) {
        const triggerParams = new URLSearchParams(triggerPathSplit[1]);
        const currentParams = new URLSearchParams(location.search.slice(1));
        triggerParams.forEach((value, key) => {
          const paramValue = currentParams.get(key);
          if (
            (paramValue !== value && value && value !== '*')
            || (!paramValue && value === '*')
          ) {
            triggers = false;
          }
        });
      } else if (triggerPathSplit[1].length > 1) {
        triggers = false;
      }
    } else if (location.search && location.search.length && !triggerPath.includes('?') && triggerPath[triggerPath.length - 1] === '$') {
      triggers = false;
    }

    return triggers;
  } catch (err) {
    return false;
  }
};

/**
  * This function will match include/exclude path, query, domain and trafficPercentage
  *
  * @param {Boolean} show
  * @param {object} banner Web Banner
  * @returns {Boolean}
  */
export const matchElementPathAndDomain = async (show, element, ignoreTrafficPercentage) => {
  if (show && element.matchPath) {
    show = triggerPathAndQuery(element.matchPath);
  }

  if (show && element.notMatchPath) {
    show = !(new RegExp(element.notMatchPath).test(window.location.pathname));
  }

  if (show && element.matchDomain) {
    const domain = element.matchDomain.replace('https://', '');
    show = new RegExp(domain).test(window.location.hostname || window.location.host);
  }

  if (show && element.matchQuery) {
    Object.keys(element.matchQuery || {}).forEach((query) => {
      if (element.matchQuery[query]) {
        show = show && window.location.search && window.location.search.indexOf(`${query}=${element.matchQuery[query]}`) > -1;
      }
    });
  }

  if (show && element.matchFunction) {
    try {
      const value = eval(element.matchFunction);
      if (typeof value === 'object' && value.then) {
        try {
          show = !!(await value);
        } catch (err) {
          log.debug(err);
        }
      } else {
        show = !!value;
      }
    } catch (err) {
      show = false;
      log.debug(err);
    }
  }

  if (!ignoreTrafficPercentage
    && show
    && !isNaN(element.trafficPercentage)
    && element.trafficPercentage > 0
    && element.trafficPercentage < 100) {
    show = (element.trafficPercentage / 100) > Math.random();
  }
  return show;
};
